/* WowStore scrolly gallery v4 — 2026-08-10
   Desktop PDP infinite film strip:
   - media column sticks and EXPANDS to the viewport (no dead space; next image peeks below)
   - images translate vertically at TEXT SPEED (PACE 1:1 with page scroll)
   - infinite: after the last image the first follows seamlessly (cloned lead slides + modulo wrap)
   - thumbnail click GLIDES smoothly to that image and scroll continues from there
   - thumbnail ladder extends to the same height */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(min-width: 1025px)').matches) return;

  var STICKY_TOP = 30;
  var BOTTOM_GAP = 30;
  var PACE_MIN = 1.0;    // text speed ("just as text") — used when the strip is short (it loops)
  var PACE_MAX = 1.4;    // gentle cap for media-heavy products so more of the set appears
  var DAMPING = 0.09;    // glide weight toward target (also used for thumb-click travel)

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var section = document.querySelector('.main-product');
      var mediaCol = section && section.querySelector('.product-detail__media');
      var infoCol = section && section.querySelector('.product-detail__information');
      var swt = mediaCol && mediaCol.querySelector('slide-with-thumbs');
      var sw = swt && swt.globalSlide;
      if (!section || !mediaCol || !infoCol || !swt) { if (tries > 60) clearInterval(timer); return; }
      if (!sw || !sw.slides || sw.slides.length < 2) { if (tries > 60) clearInterval(timer); return; }
      clearInterval(timer);
      init(mediaCol, infoCol);
    }, 250);
  });

  function init(mediaCol, infoCol) {
    var style = document.createElement('style');
    style.textContent =
      '@media (min-width:1025px){' +
      '.main-product .product-detail__media{position:sticky;top:' + STICKY_TOP + 'px;align-self:flex-start;}' +
      '.main-product .product-detail__media .swiper-slide[data-wow-clone] .media-gallery__image{pointer-events:none;}' +
      '}';
    document.head.appendChild(style);

    var currentRaw = 0;      // smoothed, unwrapped strip position
    var targetRaw = 0;       // scroll-mapped, unwrapped target
    var clickOffset = 0;     // realignment added by thumbnail clicks

    function getSwiper() {
      var swt = mediaCol.querySelector('slide-with-thumbs');
      var sw = swt && swt.globalSlide;
      return (sw && !sw.destroyed && sw.slides && sw.slides.length) ? sw : null;
    }

    function containerHeight() {
      return Math.max(480, window.innerHeight - STICKY_TOP - BOTTOM_GAP);
    }

    /* Ensure vertical direction, expanded container, peek layout and wrap clones.
       Cheap to call every tick; only does work when state is missing (e.g. after
       a variant-change rebuilt the gallery). Returns geometry or null. */
    function ensureSetup() {
      var sw = getSwiper();
      if (!sw) return null;
      try {
        var wrapper = sw.wrapperEl;
        var originals = wrapper.querySelectorAll('.swiper-slide:not([data-wow-clone])');
        var N = originals.length;
        if (N < 2) return null;
        var needH = containerHeight();
        var dirty = false;

        if (sw.params.direction !== 'vertical') {
          sw.el.style.height = needH + 'px';
          sw.changeDirection('vertical');
          dirty = true;
        }
        if (Math.abs(sw.el.offsetHeight - needH) > 4) { sw.el.style.height = needH + 'px'; dirty = true; }
        if (sw.params.slidesPerView !== 'auto') { sw.params.slidesPerView = 'auto'; dirty = true; }

        var slideStep = originals[0].offsetHeight || 720;
        var clonesNeeded = Math.min(N, Math.ceil(needH / slideStep) + 1);
        var clones = wrapper.querySelectorAll('.swiper-slide[data-wow-clone]');
        if (clones.length !== clonesNeeded) {
          clones.forEach ? clones.forEach(function (c) { c.remove(); }) : Array.prototype.forEach.call(clones, function (c) { c.remove(); });
          for (var i = 0; i < clonesNeeded; i++) {
            var c = originals[i].cloneNode(true);
            c.setAttribute('data-wow-clone', '1');
            c.removeAttribute('id');
            wrapper.appendChild(c);
          }
          dirty = true;
        }
        if (dirty) sw.update();

        // thumbnail ladder: same height, as many thumbs as fit
        var thumbs = sw.thumbs && sw.thumbs.swiper;
        if (thumbs && !thumbs.destroyed) {
          var tEl = thumbs.el;
          if (Math.abs(tEl.offsetHeight - needH) > 4) {
            tEl.style.height = needH + 'px';
            var tSlide = thumbs.slides && thumbs.slides[0];
            var tStep = (tSlide && tSlide.offsetHeight ? tSlide.offsetHeight : 92) + 10;
            thumbs.params.slidesPerView = Math.max(4, Math.floor(needH / tStep));
            thumbs.update();
          }
        }

        var cycle = sw.slidesGrid && sw.slidesGrid.length > N ? sw.slidesGrid[N] : N * slideStep;
        if (!(cycle > 0)) return null;
        return { sw: sw, N: N, cycle: cycle, step: slideStep, contH: needH };
      } catch (e) { return null; }
    }

    function scrolledPx() {
      var rect = infoCol.getBoundingClientRect();
      var raw = STICKY_TOP - rect.top;                       // 0 when columns pin
      var maxRange = rect.height - containerHeight();        // sticky travel range
      return Math.min(Math.max(raw, 0), Math.max(maxRange, 0));
    }

    var pace = PACE_MIN;
    function computeTarget() {
      targetRaw = Math.max(0, scrolledPx() * pace + clickOffset);
    }
    function tunePace(geo) {
      var range = infoCol.getBoundingClientRect().height - containerHeight();
      if (range > 400) pace = Math.min(PACE_MAX, Math.max(PACE_MIN, geo.cycle / range));
    }
    window.addEventListener('scroll', computeTarget, { passive: true });
    window.addEventListener('resize', computeTarget);

    // Thumbnail click → realign mapping so the strip GLIDES to that image
    mediaCol.addEventListener('click', function (e) {
      var thumbSlide = e.target.closest('.thumbnail-slide .swiper-slide');
      if (!thumbSlide) return;
      var geo = ensureSetup();
      if (!geo) return;
      e.stopPropagation();
      e.preventDefault();
      var thumbs = geo.sw.thumbs && geo.sw.thumbs.swiper;
      var list = thumbs ? Array.prototype.slice.call(thumbs.slides) : [];
      var k = list.indexOf(thumbSlide);
      if (k < 0 || k >= geo.N) return;
      var Tk = geo.sw.slidesGrid[k];
      var cur = currentRaw % geo.cycle;
      var delta = ((Tk - cur) % geo.cycle + geo.cycle * 1.5) % geo.cycle - geo.cycle / 2; // shortest path
      var newTarget = currentRaw + delta;
      if (newTarget < 0) newTarget = currentRaw + delta + geo.cycle; // can't rewind below start: wrap forward
      clickOffset += newTarget - targetRaw;
      targetRaw = newTarget;
    }, true);

    (function loop() {
      requestAnimationFrame(loop);
      var geo = ensureSetup();
      if (!geo || geo.sw.params.direction !== 'vertical') return;
      tunePace(geo);
      var delta = targetRaw - currentRaw;
      if (Math.abs(delta) < 0.4) return;
      currentRaw += delta * DAMPING;
      // keep the unwrapped coords from growing unbounded
      if (currentRaw > geo.cycle * 3 && targetRaw > geo.cycle * 3) {
        currentRaw -= geo.cycle; targetRaw -= geo.cycle; clickOffset -= geo.cycle;
      }
      var T = ((currentRaw % geo.cycle) + geo.cycle) % geo.cycle;
      try {
        var sw = geo.sw;
        sw.setTranslate(-T);
        sw.updateActiveIndex();
        sw.updateSlidesClasses();
        var idx = sw.activeIndex % geo.N;
        var thumbs = sw.thumbs && sw.thumbs.swiper;
        if (thumbs && !thumbs.destroyed && thumbs.activeIndex !== idx) thumbs.slideTo(idx, 300);
      } catch (e) { /* mid-rebuild; next frame recovers */ }
    })();
  }
})();
